import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getWorkloadQueryKey } from 'hooks/queries/workload-optimization/useWorkloadQuery';
import { getWorkloadScalingPoliciesQueryKey } from 'hooks/queries/workload-optimization/useWorkloadScalingPoliciesQuery';
import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

type UseDeleteWorkloadScalingPolicyMutationArgs = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteWorkloadScalingPolicyMutation = ({
  onSuccess,
  onError,
}: UseDeleteWorkloadScalingPolicyMutationArgs = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.workloadOptimization.deleteWorkloadScalingPolicy,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getWorkloadScalingPoliciesQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getWorkloadQueryKey() });
      queryClient.invalidateQueries({
        queryKey: getWorkloadsQueryKey(),
      });
      notify.success('Workload scaling policy successfully deleted');
      onSuccess?.();
    },
    onError: () => {
      notify.error('Failed to delete scaling policy');
      onError?.();
    },
  });
};
